import types from "../actionTypes";

export default (
  state = {
    profileImageURL: undefined,
    isSideMenuOpen: false,
    successMessage: "",
    fileHistory: [],
    notificationMarqueeText: ""
  },
  action
) => {
  switch (action.type) {
    case types.SET_UPDATED_PROFILEPHOTO:
      return Object.assign({}, state, {
        profileImageURL: action.profileImageURL,
      });
    case types.IS_MENU_OPEN:
      return Object.assign({}, state, {
        isSideMenuOpen: action.isSideMenuOpen,
      });
    case types.SET_JOB:
      return Object.assign({}, state, {
        job: action.job,
      });
    case types.SET_SUPERVISOR_LIST:
      return Object.assign({}, state, {
        supervisorList: action.supervisorList,
      });
    case types.SET_SUCCESS_MESSAGE:
      return Object.assign({}, state, { successMessage: action.successMessage });
    case types.SET_FILE_HISTORY:
      return Object.assign({}, state, { fileHistory: action.fileHistory });
    case types.SET_MARQUEE_TEXT:
      return Object.assign({}, state, { notificationMarqueeText: action.notificationMarqueeText });
    default:
      return state;
  }
};
